import { ErrorHandler } from "@angular/core";

import { getLogger } from "skCommon/utils/logger";

export class LoggerErrorHandler implements ErrorHandler {
    public handleError(error) {
        getLogger().error(error);
    }
}
